import type { RouteObject } from 'react-router';

import { CommentsPage } from './Comments';

/**
 * `/comments` — the pre-publication comment moderation queue.
 *
 * It sits in the pack's `moderation/` folder beside the two report surfaces and
 * shares none of their records: this queue holds comments and its decisions are
 * release and remove, the report queue holds cases owned by a different service,
 * and neither route resolves an item belonging to the other. The folder is a
 * file-organisation fact; the URL carries no bucket segment.
 *
 * It adds no loader — the console layout route runs the guard chain, and
 * `backend-engagement` re-checks the caller's own role on the request itself.
 */
export const commentsRoute: RouteObject = {
  path: 'comments',
  element: <CommentsPage />,
};
